import type { MegaMillionsParticipation } from '../../../types';
import { extractBaseWinnings, registerCalculator, type WinningsCalculationData } from './calculators';

/**
 * MegaMillions winnings calculator.
 * Applies per-line multipliers from multipliersPerLine when multiplier is enabled.
 */
function calculateMegaMillionsWinnings({ participation, currency }: WinningsCalculationData): number {
  const { multipliersPerLine } = participation as MegaMillionsParticipation;
  const winnings = extractBaseWinnings(participation.lineWinningInfo, currency);

  return winnings.reduce((sum: number, value: number, index: number) => {
    const lineNumber = (index + 1).toString();
    const multiplier = multipliersPerLine?.[lineNumber] ?? 1;
    return sum + value * multiplier;
  }, 0);
}

registerCalculator('megaMillions', calculateMegaMillionsWinnings);

export { calculateMegaMillionsWinnings };
